/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum Status {
  OFF = "OFF",
  ON = "ON",
  PENDING_OFF = "PENDING_OFF",
  PENDING_ON = "PENDING_ON",
}


export enum _ModelMutationType {
  CREATED = "CREATED",
  DELETED = "DELETED",
  UPDATED = "UPDATED",
}


export interface AllBotiesQuery {
  allBoties:  Array< {
    __typename: "Botie",
    id: string,
    token: string,
    name: string | null,
    note: string | null,
    status: Status,
    owner:  {
      __typename: "User",
      email: string,
      id: string,
      name: string | null,
    },
  } >,
};

export interface SubscribeBotieSubscription {
  Botie:  {
    __typename: "BotieSubscriptionPayload",
    mutation: _ModelMutationType,
    node:  {
      __typename: "Botie",
      id: string,
      token: string,
      name: string | null,
      note: string | null,
      status: Status,
      owner:  {
        __typename: "User",
        email: string,
        id: string,
        name: string | null,
      },
    } | null,
    previousValues:  {
      __typename: "BotiePreviousValues",
      id: string,
    } | null,
  } | null,
};

export interface DeleteBotieMutationVariables {
  id: string,
};

export interface DeleteBotieMutation {
  deleteBotie:  {
    __typename: "Botie",
    id: string,
  } | null,
};

export interface CreateBotieMutationVariables {
  token: string,
  name: string,
  ownerId: string,
};

export interface CreateBotieMutation {
  createBotie:  {
    __typename: "Botie",
    id: string,
    token: string,
    name: string | null,
    note: string | null,
    status: Status,
    owner:  {
      __typename: "User",
      email: string,
      id: string,
      name: string | null,
    },
  } | null,
};

export interface UpdateBotieMutationVariables {
  id: string,
  name?: string | null,
  note?: string | null,
};

export interface UpdateBotieMutation {
  updateBotie:  {
    __typename: "Botie",
    id: string,
    token: string,
    name: string | null,
    note: string | null,
    status: Status,
    owner:  {
      __typename: "User",
      email: string,
      id: string,
      name: string | null,
    },
  } | null,
};

export interface BotieFragment {
  __typename: "Botie",
  id: string,
  token: string,
  name: string | null,
  note: string | null,
  status: Status,
  owner:  {
    __typename: "User",
    email: string,
    id: string,
    name: string | null,
  },
};
